// ============================================================
// HOTEL RAJ — central data file.
// Owner: replace images with your own hotel/room photos later.
// Sirf is file mein photos/number badalna hai, baaki sab update ho jayega.
// ============================================================

export const HOTEL = {
  name: "Hotel Raj",
  tagline: "Royal Comfort & Timeless Hospitality",
  address: "Ghorasahan Road, Near Overbridge, Dhaka, East Champaran, Bihar",
  shortAddress: "Ghorasahan Road, Near Overbridge, Dhaka",
  totalRooms: 20,
  ratePerNight: 5500,
  phone: "+91 89358 08515",
  phoneHref: "tel:+918935808515",
  mapUrl:
    "https://www.google.com/maps/search/?api=1&query=Ghorasahan+Road+Near+Overbridge+Dhaka+East+Champaran+Bihar",
};

export const inr = (n) => `₹${Number(n).toLocaleString("en-IN")}`;

export const IMAGES = {
  hero: "https://customer-assets-0z36b82j.emergentagent.net/job_hotel-raj-reserve/artifacts/9iu4r47z_hotel%20front%20pic.jpeg",
  story: "https://customer-assets-0z36b82j.emergentagent.net/job_hotel-raj-reserve/artifacts/x4xiyatw_222.jpg",
  storySmall: "https://customer-assets-0z36b82j.emergentagent.net/job_hotel-raj-reserve/artifacts/795vvd7t_30.jpg",
  dining: "https://images.unsplash.com/photo-1692153142524-60285a93c249?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwyfHxsdXh1cnklMjBob3RlbCUyMGFyY2hpdGVjdHVyZSUyMGxpZ2h0aW5nfGVufDB8fHx8MTc5MDg3NzU5OXww&ixlib=rb-4.1.0&q=85",
};

export const ROOMS = [
  {
    name: "Deluxe Room",
    desc: "Our classic deluxe stay — plush double bed, cosy seating nook and a flat-screen TV in warm light.",
    img: "https://customer-assets-0z36b82j.emergentagent.net/job_hotel-raj-reserve/artifacts/dhs6iqrm_room%201.jpg",
  },
  {
    name: "Premium AC Room",
    desc: "Air-conditioned comfort with a large double bed, wall-mounted TV and soft evening drapes.",
    img: "https://customer-assets-0z36b82j.emergentagent.net/job_hotel-raj-reserve/artifacts/1wa5nres_33.jpg",
  },
  {
    name: "Spacious Double Room",
    desc: "Room to stretch out — a wide bed, tea kettle at your bedside and quiet, restful nights.",
    img: "https://customer-assets-0z36b82j.emergentagent.net/job_hotel-raj-reserve/artifacts/x4xiyatw_222.jpg",
  },
];

export const GALLERY = [
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_hotel-raj-reserve/artifacts/9iu4r47z_hotel%20front%20pic.jpeg", alt: "Hotel Raj — front view, Near Overbridge Ghorasahan Road Dhaka" },
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_hotel-raj-reserve/artifacts/dhs6iqrm_room%201.jpg", alt: "Deluxe Room" },
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_hotel-raj-reserve/artifacts/1wa5nres_33.jpg", alt: "Premium AC Room" },
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_hotel-raj-reserve/artifacts/x4xiyatw_222.jpg", alt: "Spacious Double Room" },
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_hotel-raj-reserve/artifacts/795vvd7t_30.jpg", alt: "Guest room with mini-fridge and TV" },
];

export const AMENITIES = [
  { icon: "clock", title: "24/7 Room Service", desc: "Round-the-clock in-room dining and housekeeping." },
  { icon: "utensils", title: "Multi-Cuisine Dining", desc: "Bihari classics, North Indian favourites and more." },
  { icon: "wifi", title: "High-Speed Wi-Fi", desc: "Complimentary fibre internet in every room." },
  { icon: "banquet", title: "Banquet Hall", desc: "Celebrate weddings and functions with ease." },
  { icon: "zap", title: "Power Backup", desc: "Full-generator backup — comfort never blinks." },
  { icon: "car", title: "Valet Parking", desc: "Safe, assisted parking right at the porch." },
  { icon: "snow", title: "AC & Non-AC Rooms", desc: "Air-conditioned and non-AC options for every budget." },
  { icon: "droplets", title: "Hot & Cold Water", desc: "On tap, around the clock." },
];

export const MARQUEE_ITEMS = [
  "Royal Comfort",
  "20 Luxury Rooms",
  "East Champaran",
  "Hotel Raj, Dhaka",
  "₹5,500 Per Night",
];
